import * as icons from '../../Icons/index';
import * as Types from '../types/global';
import * as Gear from './gear';
import * as Items from './items';
import * as Material from './materials';

export const maxHp = 10;

export const emptyPlayer: Types.Player =
{
    type: 'Player',
    name: 'Hero',
    hp: maxHp,
    maxHp: maxHp,
    defense: 0,
    symbol: icons.heroFront,
    data: { x: 0, y: 0 },
    inventory: [],
    quiver: [],
    hotBar: { Equippeable: [ ] },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    buffs:
    {
        flags: { HoT: false },
        instances: { HotInstances: [] } 
    }
}

export const trap: Types.Trap =
{
    type: 'Trap',
    id: '0',
    name: 'Simple trap',
    symbol: icons.trapImg,
    active: true,
    data: { x: 0, y: 0 },
    attack: { Instant: 1, DoT: 0, Times: 0, Aliment: 'none' }
}

export const poisonTrap: Types.Trap =
{
    type: 'Trap',
    id: '0',
    name: 'Poison trap',
    symbol: icons.pTrapImg,
    active: true,
    data: { x: 0, y: 0 },
    attack: { Instant: 1, DoT: 2, Times: 3, Aliment: 'poison' },
}

export const allTraps: Types.Trap[] = [
    trap, poisonTrap
]

export const chest1: Types.Enemy =
{
    type: 'Enemy',
    id: '0',
    name: 'Chest',
    hp: 3,
    maxHp: 3,
    symbol: icons.chest,
    data: { x: 0, y: 0 },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    attack: { Instant: 0, DoT: 0, Times: 0, Aliment: 'none' },
    defense: { armor: 0, toughness: 1, immunity: 'bleed' },
    patrol: { pattern: 'none', moveSpeed: 0 },
    drops: [ ]
}

export const enemy: Types.Enemy =
{
    type: 'Enemy',
    id: '0',
    name: 'Goblin',
    hp: 5,
    maxHp: 5,
    symbol: icons.goblinImg,
    data: { x: 0, y: 0 },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    attack: { Instant: 2, DoT: 0, Times: 0, Aliment: 'none' },
    defense: { armor: 0, toughness: 1 },
    patrol: { pattern: 'horizontal', moveSpeed: 1000 },
    drops: [ { item: Items.Potion, chance: 10, quantity: 3 }, { item: Gear.Necklace1, chance: 5, quantity: 1 } ]
}

export const heavyEnemy: Types.Enemy =
{
    type: 'Enemy',
    id: '0',
    name: 'Veteran Goblin',
    hp: 11,
    maxHp: 11,
    symbol: icons.hGoblinImg,
    data: { x: 0, y: 0 },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    attack: { Instant: 3, DoT: 1, Times: 4, Aliment: 'bleed' },
    defense: { armor: 1, toughness: 3, immunity: 'bleed' },
    patrol: { pattern: 'vertical', moveSpeed: 2000 },
    drops: [ { item: Items.Antidote, chance: 15, quantity: 1 }, { item: Gear.Dagger1, chance: 5, quantity: 1 }, { item: Items.Bandages, chance: 25, quantity: 2 } ]
}

export const agileEnemy: Types.Enemy =
{
    type: 'Enemy',
    id: '0',
    name: 'Hasty Goblin',
    hp: 4,
    maxHp: 4,
    symbol: icons.snsGoblinImg,
    data: { x: 0, y: 0 },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    attack: { Instant: 1, DoT: 0, Times: 0, Aliment: 'none' },
    defense: { armor: 1, toughness: 3 },
    patrol: { pattern: 'random', moveSpeed: 500 },
    drops: [ { item: Items.Aloe, chance: 35, quantity: 1 } ]
};

export const minerEnemy: Types.Enemy =
{
    type: 'Enemy',
    id: '0',
    name: 'Miner Goblin',
    hp: 3,
    maxHp: 3,
    symbol: icons.minerGoblin,
    data: { x: 0, y: 0 },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    attack: { Instant: 1, DoT: 0, Times: 0, Aliment: 'none' },
    defense: { armor: 0, toughness: 1 },
    patrol: { pattern: 'random', moveSpeed: 1000 },
    drops: [ { item: Material.CopperOre, chance: 45, quantity: 1 }, { item: Gear.CopperPickaxe, chance: 15, quantity: 1 } ]
};

export const weakEnemy: Types.Enemy =
{
    type: 'Enemy',
    id: '0',
    name: 'Rookie Goblin',
    hp: 3,
    maxHp: 3,
    symbol: icons.pDummy,
    data: { x: 0, y: 0 },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    attack: { Instant: 1, DoT: 0, Times: 0, Aliment: 'none' },
    defense: { armor: 0, toughness: 1, immunity: 'none' },
    patrol: { pattern: 'vertical', moveSpeed: 2000 },
    drops: [ { item: Gear.Necklace1, chance: 15, quantity: 1 } ]
}

export const vScorpion: Types.Enemy =
{
    type: 'Enemy',
    id: '0',
    name: 'Scorpion',
    hp: 5,
    maxHp: 5,
    symbol: icons.pScorpion,
    data: { x: 0, y: 0 },
    aliments:
    {
        flags: { Poisoned: false, Bleeding: false, Burning: false },
        instances: { PoisonInstances: [], BleedInstances: [], BurnInstances: [] }
    },
    attack: { Instant: 1, DoT: 1, Times: 5, Aliment: 'poison' },
    defense: { armor: 0, toughness: 1 },
    patrol: { pattern: 'random', moveSpeed: 750 },
    drops: [ { item: Material.PoisonClaw, chance: 99, quantity: 1 } ]
};

export const allEnemies: Types.Enemy[] = [
    enemy, weakEnemy, heavyEnemy, agileEnemy, minerEnemy, vScorpion, chest1
];